//var getSelectData = $("#SiteNavSearchCart .pick_currency").html();
//var getNiceData = $("#SiteNavSearchCart .pick_currency .nice-select").html();
//$("#StickyBar .sticky-only .pick_currency").append('<div class="nice-select undefined">'+getNiceData+'</div><i class="fa mldarrow fa-angle-down"></i>'); 

//when scrolling...
$(window).scroll(function() {

    if($(window).scrollTop() >= 115){
         //console.log("add");
         $("#SiteNavSearchCart .pick_currency").addClass("trj-currency-floating");
         //$("#SiteNavSearchCart .pick_currency").css("background-color","#000 !important");
      	
      	if ($(window).width() < 1060) {
          
           //$("#SiteNavSearchCart .pick_currency").removeClass("trj-currency-floating");
           //$("#SiteNavSearchCart .pick_currency").addClass("trj-currency-floating1060");
        }  
      
      
    }else{
    	 $("#SiteNavSearchCart .pick_currency").removeClass("trj-currency-floating");
         //$("#SiteNavSearchCart .pick_currency").css("background-color","inherit !importantt");
      	 //console.log("remove");
    }
});

$(document).ready(function(){
    $(".product-single__photo .image-zoom")
      .wrap('<span class="cusZoomCls clearfix" style="display:block"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
        url: $(this).find('img').attr('data-zoom')
      });
   
   
    setTimeout(function() {
        jQuery(".trj-custom-offer").css("z-index","4");
        jQuery(".site-header .meganav.meganav--active").css("z-index","6");
        jQuery(".TempDivforZoom").css("display","none");
    }, 2000);

   
  $(".hhhide").addClass("hide");
  
});
 




